import React from 'react';
import SEO from '../../components/ui/SEO';
import { Link } from 'react-router-dom';
import Button from '../../components/ui/Button';
import { HeartPulse, CheckCircle } from 'lucide-react';
export default function TraumaPTSD() {
  return <main className="min-h-screen bg-white" data-id="element-1343" data-mp="1oap70exm96ok">
      <SEO title="PTSD and Trauma Reports | Psychiatric Injury Claims" description="Independent PTSD, complex PTSD and psychiatric injury reports for civil claims and Istanbul Protocol matters. Instruct Dr Syed today." path="/services/trauma-ptsd" keywords={['PTSD expert witness report', 'psychiatric injury assessment', 'complex PTSD medico-legal report', 'Istanbul Protocol psychiatric report']} imageAlt="PTSD and psychiatric injury reports for civil claims" schema={{
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'PTSD and Trauma Evaluations',
      serviceType: 'PTSD and psychiatric injury assessment',
      url: 'https://medicolegal-psychiatry.co.uk/services/trauma-ptsd',
      areaServed: {
        '@type': 'AdministrativeArea',
        name: 'England and Wales'
      },
      provider: {
        '@type': 'Organization',
        name: 'Medicolegal Psychiatry',
        url: 'https://medicolegal-psychiatry.co.uk'
      },
      audience: {
        '@type': 'Audience',
        name: 'Legal professionals'
      },
      description: 'Assessment of PTSD, complex PTSD and psychiatric injury, addressing diagnosis, causation and prognosis for legal proceedings.'
    }} data-id="element-1344" data-mp="1jcdws33esu5t" />
      {/* Hero Section */}
      <section className="bg-primary text-white py-16 pt-24 md:pt-28" data-id="element-1345" data-mp="2mih3v2w87kss">
        <div className="container mx-auto px-4" data-id="element-1346" data-mp="1p33b9ojhqihw">
          <div className="flex items-center justify-center mb-6" data-id="element-1347" data-mp="1p08s00c7r3q2">
            <HeartPulse className="h-16 w-16 mr-4" data-id="element-1348" data-mp="1u03i41o5zpa2" />
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold" data-id="element-1349" data-mp="2xcbwdyflmuvv">
              PTSD & Trauma Psychiatric Evaluations
            </h1>
          </div>
          <p className="text-xl max-w-3xl mx-auto text-center" data-id="element-1350" data-mp="2scz0ko6r2dh5">
            Expert Insights into Psychological Injury
          </p>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-16" data-id="element-1351" data-mp="323k7r00hoqbo">
        <div className="container mx-auto px-4" data-id="element-1352" data-mp="325ek3pxp3a45">
          <div className="max-w-3xl mx-auto" data-id="element-1353" data-mp="2eehf6x4bhd2e">
            <p className="text-slate-dark text-lg mb-6" data-id="element-1354" data-mp="2efapu96ecmpt">
              Understanding the profound impact of trauma is crucial in many
              legal contexts. Dr. Imtiaz Syed provides meticulous and sensitive
              assessments for Post-Traumatic Stress Disorder (PTSD) and Complex
              PTSD, offering clear and robust expert opinions for legal
              proceedings. His evaluations help illuminate the psychological
              consequences of traumatic events, ensuring these are accurately
              presented and understood within the legal framework.
            </p>
            <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-1355" data-mp="a7g1rh7xq8ld">
              Why Instruct Dr. Imtiaz Syed for Trauma & PTSD Evaluations?
            </h2>
            <p className="text-slate-dark mb-4" data-id="element-1356" data-mp="3sem1y0dwv3xd">
              Dr. Syed's expertise in trauma-informed psychiatry ensures:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-1357" data-mp="owcalghtfpn1">
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1358" data-mp="oyf5oexts8ym">
                <div className="flex items-start" data-id="element-1359" data-mp="tudqxtnuxaut">
                  <CheckCircle className="h-5 w-5 text-secondary mr-2 mt-1" data-id="element-1360" data-mp="tx89ffnb8lll" />
                  <div data-id="element-1361" data-mp="f696ol95or9x">
                    <h3 className="font-bold text-primary" data-id="element-1362" data-mp="k5m39xptxcpp">
                      Sensitive & Thorough Assessments
                    </h3>
                    <p className="text-slate" data-id="element-1363" data-mp="17u5ae9x57jg7">
                      Conducted with deep understanding and respect for the
                      individual's experience.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1364" data-mp="3g3wb95jiwkx5">
                <div className="flex items-start" data-id="element-1365" data-mp="3g2bgbetaqzyr">
                  <CheckCircle className="h-5 w-5 text-secondary mr-2 mt-1" data-id="element-1366" data-mp="3b4jnmiktv9ti" />
                  <div data-id="element-1367" data-mp="3b6moxyrfkpdj">
                    <h3 className="font-bold text-primary" data-id="element-1368" data-mp="365yqis0vh69a">
                      Istanbul Protocol Compliance
                    </h3>
                    <p className="text-slate" data-id="element-1369" data-mp="7mrswwfb4brm">
                      Reports for international contexts (e.g., asylum) often
                      adhere to these rigorous standards.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1370" data-mp="3p52w1qt7ghw7">
                <div className="flex items-start" data-id="element-1371" data-mp="3p2gnpoyhpycx">
                  <CheckCircle className="h-5 w-5 text-secondary mr-2 mt-1" data-id="element-1372" data-mp="qfm89rgue5wd" />
                  <div data-id="element-1373" data-mp="lo43esbp7l64">
                    <h3 className="font-bold text-primary" data-id="element-1374" data-mp="lmt2d09n0rip">
                      Clarifying Complex Trauma
                    </h3>
                    <p className="text-slate" data-id="element-1375" data-mp="t0tq0bduwwyc">
                      Expertise in assessing conditions arising from torture,
                      gender-based violence (GBV), modern slavery, and other
                      severe experiences.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1376" data-mp="1by4ldkwdb68i">
                <div className="flex items-start" data-id="element-1377" data-mp="1bxl2a0uzebsw">
                  <CheckCircle className="h-5 w-5 text-secondary mr-2 mt-1" data-id="element-1378" data-mp="1gwfu1saxfap5" />
                  <div data-id="element-1379" data-mp="1lno50srwn44f">
                    <h3 className="font-bold text-primary" data-id="element-1380" data-mp="1ln4ptjtn2tu3">
                      Objective & Robust Reports
                    </h3>
                    <p className="text-slate" data-id="element-1381" data-mp="1qm7uh35piy1j">
                      Providing impartial, evidence-based findings that clearly
                      outline diagnosis, causation, and prognosis where
                      relevant.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-1382" data-mp="3roywekh9gggo">
              Key Trauma & PTSD Assessments Provided
            </h2>
            <p className="text-slate-dark mb-4" data-id="element-1383" data-mp="9c0zynjog5r9">
              Dr. Syed offers expert evaluations for:
            </p>
            <ul className="space-y-3 mb-8 text-slate-dark" data-id="element-1384" data-mp="4ipq0djkj8v4">
              <li className="flex items-start" data-id="element-1385" data-mp="j8dv7puvero4">
                <span className="text-secondary font-bold mr-2" data-id="element-1386" data-mp="jb9tjfamrid3">•</span>
                <span data-id="element-1387" data-mp="e9anfxnia7cg">
                  <strong data-id="element-1388" data-mp="e9u4lc5c0rpf">Post-Traumatic Stress Disorder (PTSD):</strong>{' '}
                  Diagnostic assessments for the classic presentation of PTSD.
                </span>
              </li>
              <li className="flex items-start" data-id="element-1389" data-mp="o91hxzc2gmcj">
                <span className="text-secondary font-bold mr-2" data-id="element-1390" data-mp="2u0ot825qnmnz">•</span>
                <span data-id="element-1391" data-mp="2u31hex23at9h">
                  <strong data-id="element-1392" data-mp="2q04uiu5ioazq">Complex PTSD:</strong> Evaluations for prolonged,
                  repeated, or multiple forms of trauma.
                </span>
              </li>
              <li className="flex items-start" data-id="element-1393" data-mp="2fy2cghe3qk76">
                <span className="text-secondary font-bold mr-2" data-id="element-1394" data-mp="2jw8e5b0329l8">•</span>
                <span data-id="element-1395" data-mp="266epasokvpbi">
                  <strong data-id="element-1396" data-mp="264twb7hwwefr">Trauma-Related Psychological Injuries:</strong>{' '}
                  Assessments in personal injury claims where trauma has led to
                  psychological distress.
                </span>
              </li>
              <li className="flex items-start" data-id="element-1397" data-mp="1w9tka7ck6e7o">
                <span className="text-secondary font-bold mr-2" data-id="element-1398" data-mp="21721a4lz0c7c">•</span>
                <span data-id="element-1399" data-mp="1n70u67f448jf">
                  <strong data-id="element-1400" data-mp="1n7sozg0vy28n">Impact of Specific Traumatic Events:</strong> Expert
                  opinions on the psychological effects of accidents, abuse, or
                  other significant incidents.
                </span>
              </li>
            </ul>
            <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-1401" data-mp="3hj7go2dgibr1">
              Our Seamless Process & Robust Reports
            </h2>
            <p className="text-slate-dark mb-6" data-id="element-1402" data-mp="yy4q9yaac0mo">
              Our assessment process is thorough and efficient, involving
              careful review of documentation and sensitive clinical interviews.
              Dr. Syed offers both secure remote assessments across the UK and
              in-person consultations when appropriate. The resulting reports
              are always clear, legally relevant, and provide precise findings
              and actionable insights for your case, designed to withstand
              scrutiny.
            </p>
            <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-1403" data-mp="bby7cgzbp0ho">
              Partnering for Just Outcomes
            </h2>
            <p className="text-slate-dark mb-6" data-id="element-1404" data-mp="29p328une3cq">
              Dr. Imtiaz Syed is your trusted partner in navigating the
              complexities of trauma-related claims. His expert evaluations
              provide the clarity and depth required to ensure psychological
              injuries are understood and justly addressed within the legal
              system.
            </p>

            {/* Related Services */}
            <div className="mb-10 border-t border-gray-200 pt-8" data-id="element-1405" data-mp="3ji3bto0cody5">
              <h3 className="text-xl font-serif font-bold text-primary mb-4" data-id="element-1406" data-mp="3oa4hgr30j6f7">
                Explore Our Other Services
              </h3>
              <div className="flex flex-col sm:flex-row flex-wrap gap-4" data-id="element-1407" data-mp="3sb6jffobdwkv">
                <Link to="/services/specialist" className="text-secondary hover:text-primary font-medium underline transition-colors" data-id="element-1408" data-mp="2vmqqrapwr73j">
                  Psychiatric Reports for Courts & Tribunals
                </Link>
                <Link to="/services/clinical-negligence" className="text-secondary hover:text-primary font-medium underline transition-colors" data-id="element-1409" data-mp="39lzxzkw4yqvd">
                  Clinical Negligence Cases
                </Link>
                <Link to="/services/forensic-risk" className="text-secondary hover:text-primary font-medium underline transition-colors" data-id="element-1410" data-mp="oxc6obtmxk1a">
                  Forensic & Risk Assessments
                </Link>
              </div>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg shadow-md mb-8" data-id="element-1411" data-mp="1f7v2m2g6vhqp">
              <h3 className="text-xl font-serif font-bold text-primary mb-4" data-id="element-1412" data-mp="1k3jxhsh9kago">
                Ready to Instruct Dr. Syed?
              </h3>
              <p className="text-slate-dark mb-4" data-id="element-1413" data-mp="rg65m8sfa53f">
                We invite you to discuss your specific case requirements.
              </p>
              <div className="flex items-center" data-id="element-1414" data-mp="we7mcn2dlsbq">
                <span className="mr-2 text-slate-dark" data-id="element-1415" data-mp="whn4jyrcjhhd">Contact Us:</span>
                <a href="mailto:enquiries@medicolegal-psychiatry.co.uk" className="text-primary hover:text-secondary transition-colors" data-id="element-1416" data-mp="10i71p2bx6l3i">
                  enquiries@medicolegal-psychiatry.co.uk
                </a>
              </div>
            </div>
            <div className="text-center" data-id="element-1417" data-mp="7w6ip57tsly">
              <Button variant="primary" size="lg" href="/contact" data-id="element-1418" data-mp="3scq9mliyb1r7">
                Book a PTSD Assessment
              </Button>
            </div>
          </div>
        </div>
      </section>
    </main>;
}